module.exports = __webpack_public_path__ + "static/media/film-canister.b8e09e80.svg";